export const ugovor_o_povjerljivosti2= {
    templateId: 202.1,
    category: 16,
    templateTitle: "Ugovor o povjerljivosti - dvostran",
    templateDescription: `<p>Dvostranim ugovorom o povjerljivosti obje ugovorne strane razmjenjuju informacije koje se mogu okarakterizirati kao povjerljive.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Ugovori o povjerljivosti (eng. Non-disclosure agreement, CDA Confidential disclosure agreement i sl. ) su pravni odnosi kojima se uređuju uvjeti pod kojima ugovorne strane štite povjerljive informacije.</p>
    <p>Često se takvi ugovori nazivaju i Sporazumima o povjerljivosti i čuvanju poslovne tajne, Ugovorima o tajnosti podataka i sl..    </p>
    <p>Navedenim ugovorom, pružatelj informacije u povjerenju otkriva drugoj ugovornoj strani povjerljive informacije.     </p>
    <p>Međutim, ugovor o povjerljivosti može biti:    </p>
    <li> jednostran (unilateralan) - samo jedna ugovorna strana dijeli drugoj povjerljive informacije,</li>
    <li> dvostran (bilateralan) - obje ugovorne strane međusobno dijele povjerljive informacije,</li>
    <li> višestran (multilateralan) - više ugovornih strana međusobno dijeli povjerljive informacije.</li>
    <br>
    <p>U praksi se takav ugovor najčešće zaključuje između u trgovačkim odnosima (kod izvršenja određenih radova ili usluga,  u postupcima spajanja, pripajanja, preuzimanja društva i sl.), između poslodavca i radnika te kod ugovora o djelu ili ugovora o autorskom djelu.    </p>
    <p>Ovim tekstom te predloškom u nastavku uređuje se tematika dvostranog ugovora o povjerljivosti, dok predložak jednostranog ugovora o povjerljivosti možete pogledati <a class="local-link" href="/contract?template=202">ovdje</a>.</p>   </p>
    <p>Svrha ugovora o povjerljivosti uspostavljanje je odnosa povjerenja između ugovornih strana u cilju zaštite tajnosti povjerljivih informacija i očuvanja povjerljivih informacija.      </p>
    <p>Povjerljive informacije koje se štite mogu biti - određena specifična znanja, poslovne tajne, informacije o poslovnim partnerima ili proizvodima, tržišne informacije, strateške informacije i druge informacije koje su isključivo vlasništvo pružatelja informacije.     </p>
    <p>Ugovor o povjerljivosti, u pravilu sadrže sljedeće elemente:</p>
    <li> definiranje ugovornih strana i razloga otkrivanja povjerljivih informacija, </li>
    <li> definiranje povjerljivih informacija i izuzetaka od zaštite povjerljivosti,     </li>
    <li> obveze primatelja povjerljivih informacija,    </li>
    <li> definiranje dopuštenog korištenja povjerljivih informacija (npr. procjena interesa, korištenje u izvršenju posla i sl.),    </li>
    <li> ograničenje otkrivanja (kome je povjerljive informacije dopušteno otkriti u smislu odredbi ugovora),    </li>
    <li> vremenski rok obveze čuvanja povjerljivosti (najčešće od jedne do pet godina),    </li>
    <li> posljedice kršenja (ugovorne kazne i sl.),    </li>
    <li> nadležnost u slučaju spora.    </li>
    <br>
    <p>U hrvatskom zakonodavstvu 2018. godine je stupio na snagu Zakon o zaštiti neobjavljenih informacija s tržišnom vrijednosti koji definira bitne pojmove u pogledu zaštite poslovne tajne nositelja poslovne tajne,  određuje zakonito pribavljanje, korištenje i otkrivanje poslovnih tajni te definira postupke zaštite (tužbe, privremene mjere i sl.).      </p>
    <p>U nastavku ćemo iznijeti u bitnome sadržaj spomenutog zakona.    </p>
    <p>U smislu odredbi spomenutog zakona, nositelj poslovne tajne je svaka fizička ili pravna osoba pod čijim je zakonitim nadzorom poslovna tajna, a počinitelj povrede je svaka fizička ili pravna osoba koja je nezakonito pribavila, koristila ili otkrila poslovnu tajnu.    </p>
    <p>Spomenuti zakon definira kao poslovnu tajnu informacije koje:    </p>
    <li> nisu općenito poznate ili lako dostupne osobama iz krugova koji se obično bave predmetnom vrstom informacija,    </li>
    <li> imaju tržišnu (komercijalnu) vrijednost zbog toga što su tajne - jer mogu naštetiti znanstvenom i tehničkom potencijalu, poslovnim ili financijskim interesima, strateškim pozicijama ili sposobnosti tržišnog natjecanja,</li>
    <li> su razumno štićene u smislu tajnosti od strane osobe koja te informacije zakonito kontrolira (interni akt, mjere fizičke ili virtualne zaštite).    </li>
    <br>
    <p> Protiv počinitelja povrede, nositelj poslovne tajne može tužbom zahtijevati utvrđenje povrede, prestanak povrede odnosno zabranu korištenja ili otkrivanja poslovne tajne.    </p>
    <p> Protiv osobe koja je neovlaštenim poduzimanjem radnje prouzročila ozbiljnu prijetnju da će nezakonito pribaviti, koristiti ili otkriti poslovnu tajnu, nositelj poslovne tajne može tužbom zahtijevati prestanak poduzimanja te radnje i zabranu nezakonitog pribavljanja, korištenja ili otkrivanja poslovne tajne.    </p>
    <p>Također sukladno spomenutom zakonu te Zakonu o obveznim odnosima,  nositelj poslovne tajne (nositelj licencije) može podnijeti:    </p>
    <li> zahtjev za oduzimanje i uništenje robe kojom je počinjena povreda,    </li>
    <li> zahtjev za naknadom štete, za uobičajenom naknadom i za povratom koristi stečenom bez osnove,    </li>
    <li> zahtjev za objavu u sredstvima javnog priopćavanja na trošak tuženika pravomoćne presude kojom se u cijelosti ili djelomično udovoljilo zahtjevu usmjerenom na zaštitu poslovne tajne u slučaju nezakonitog pribavljanja, korištenja ili otkrivanja.</li>
    <br>
    <p>Osim toga, mositelj poslovne tajne koji je pokrenuo parnični postupak za zaštitu poslovne tajne od nezakonitog pribavljanja, korištenja ili otkrivanja može zahtijevati dostavu podataka o podrijetlu i distribucijskim kanalima robe ili usluge kojom je počinjena povreda.    </p>
    <p>Na zahtjev nositelja poslovne tajne, sud može odrediti bilo koju privremenu mjeru koja je usmjerena na prestanak ili sprječavanje nezakonitog pribavljanja, korištenja ili otkrivanja poslovne tajne te pod određenim uvjetima sud može na prijedlog nositelja poslovne tajne odrediti privremenu mjeru radi osiguranja dokaza.</p>

   
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o zaštiti neobjavljenih informacija s tržišnom vrijednosti, Zakon o obveznim odnosima.    </p>
  `,

  sides: [
    {
        signature: '',
        inputs: [{
            type: "input",
            required: true,
            placeholder: 'Posl. subjekt / Ime i prezime',        
          },
          {
            type: "input",
            required: true,
            placeholder: "Ulica i kućni broj",
          },
          {
            type: "input",
            required: true,
            placeholder: "Mjesto",
          },
          {
            type: "input",
            required: true,
            placeholder: "OIB",
          },
          {
            type: "input",
            placeholder: "Zastupa (za pr. osobe)",
            inSignature: true,
          },
          {
            type: "input",
            placeholder: "Funkcija (za pr. osobe)",
            inSignature: true,
          }],
        delimiter: `i`
    },
    {
        signature: '',
        inputs: [{
            type: "input",
            required: true,
            placeholder: 'Posl. subjekt / Ime i prezime',        
          },
          {
            type: "input",
            required: true,
            placeholder: "Ulica i kućni broj",
          },
          {
            type: "input",
            required: true,
            placeholder: "Mjesto",
          },
          {
            type: "input",
            required: true,
            placeholder: "OIB",
          },
          {
            type: "input",
            mandatory: false,
            editable: true,
            placeholder: "Zastupa (za pr. osobe)",
            inSignature: true,
          },
          {
            type: "input",
            placeholder: "Funkcija (za pr. osobe)",
            inSignature: true,
          }],
    }
],


  headline: 'zaključuju sljedeći',
  title: 'UGOVOR O POVJERLJIVOSTI',
  noArticleNumbers: false,
  articles: [
    {
      title: 'UVODNE ODREDBE',
      mandatory: true,
      statements: [
          {
              type: 'input',
              mandatory: true,
              parts: [
                {type: 'text', content: 'Ugovorne strane razmatraju procjenu suradnje vezanu uz'},
                  {type: 'textarea', value: '', required: true, help: 'Molimo opišite predmet suradnje uslijed koje se predaju povjerljivi podaci.'},
                  {type: 'text', content: '(u daljnjem tekstu: Transakcija).'}],

          }],
      value: '',
  },
  {
    title: 'SVRHA UGOVORA',
    mandatory: true,
    statements: [
        {
            type: 'text',
            required: false,
            mandatory: true,
            editable: true,
            content: 'Nakon sklapanja ovog Ugovora, ugovorne strane mogu međusobno predočavati i/ili dostavljati određene osjetljive informacije i dokumentaciju koji su povjerljive prirode sukladno definiciji u nastavku ovog Ugovora te se u tom smislu svaka od ugovornih strana smatra i primateljem i pružateljem informacija. \r\nPružatelj informacija je spreman predočiti i/ili dostaviti takve Povjerljive podatke (kako su definirani u ovom Ugovoru) Primatelju informacija bilo izravno ili neizravno, isključivo kako bi Primatelj informacija bila u mogućnosti procijeniti  Transakciju.\r\nPružatelj informacija želi onemogućiti otkrivanje i neovlaštenu uporabu takvih povjerljivih podataka izvan svrhe utvrđene ovim Ugovorom.\r\nUgovorne strane su spremne međusobno predočavati i/ili dostavljati takve Povjerljive podatke (kako su definirani u ovom Ugovoru) drugoj ugovornoj strani, bilo izravno ili neizravno, isključivo kako bi druga ugovorna strana bila u mogućnosti procijeniti  Transakciju.\r\nUgovorne strane žele onemogućiti otkrivanje i neovlaštenu uporabu takvih povjerljivih podataka izvan svrhe utvrđene ovim Ugovorom.            ',
            value: '',
        }],
},  
{
  title: 'POVJERLJIVI PODACI',
  mandatory: true,
  statements: [
      {
          type: 'text',
          required: false,
          mandatory: true,
          editable: true,
          content: 'Povjerljivi podaci podrazumijevaju sve usmene ili pisane, snimljene ili elektroničke dokumente, informacije ili podatke (uključujući, ali ne isključivo, računovodstvene dokumente i financijske i upravljačke izvještaje, prospekte, sporazume, ugovore i popratnu dokumentaciju o zajmovima i kreditima, izjave, licence, poslovne tajne, sankcije, odobrenja, rezultate, upute za rad, komunikaciju, korespondenciju, podatke ili informacije o poslovnim pothvatima, obeštećenjima, istraživanjima, razvoju, marketingu, prodaji, financijama, radu, rezultatima, troškovima, poslovanju i postupcima, idejama, dizajnu, baze podataka, izvorni kod, strojni kod, procese, računalne programe, know-how te alate za programiranje računala, kao i ostali softver i softverske tehnike) koje je pružatelj informacija izravno ili neizravno učinilo dostupnima primatelju informacija ili njenim Zastupnicima, a odnose se na (i) pružatelja informacija, i/ili bilo koje od njihovih povezanih osoba, i/ili (ii) poslovanje i/ili strategije pružatelja informacija i/ili bilo koje od njihovih povezanih osoba, i/ili (iii) Transakciju. \r\nRadi izbjegavanja dvojbe, Povjerljivi podaci uključuju (a) sve poslovne informacije o pružatelju informacija koje nisu javno dostupne, (b) činjenicu da ugovorne strane razmatraju Transakciju, (c) postojanje i uvjete ovog Ugovora te (d) činjenicu da ugovorne strane pregovaraju o Transakciji. \r\nZa potrebe ovog Ugovora, Povjerljivi podaci, uključuju sve kopije, sažetke, zapise, opise, izmjene i ponavljanja bilo kojeg od gore navedenih podataka, dokumenata ili drugih fizičkih objekata. \r\nPovjerljivi podaci su tajne jer nisu prema svojoj ukupnosti ili u točnoj strukturi i sklopu svojih sastavnih dijelova, općenito poznate ili lako dostupne osobama iz krugova koji se obično bave predmetnom vrstom informacija. \r\nU pogledu davanja Povjerljivih podataka, pružatelj informacija može po vlastitom slobodnom nahođenju odlučiti koje podatke će dati primatelju informacija, radi procjene interesa za Transakcijom.',
          value: '',
      }],
}, 
{
title: 'OBVEZE UGOVORNIH STRANA',
mandatory: true,
statements: [
    {
        type: 'text',
        required: false,
        mandatory: true,
        editable: true,
        content: 'U odnosu na primljene Povjerljive podatke, svaka od ugovornih strana ima sljedeće obveze: \r\na) čuvati Povjerljive podatke kao tajnu te se obvezuje da ih neće, u cijelosti niti djelomično, otkrivati bilo kojoj osobi bez prethodne pisane suglasnosti druge ugovorne strane. Ugovorna strana koja prima Povjerljive podatke, može isključivo otkriti i omogućiti pristup Povjerljivim podacima onim svojim zastupnicima koji su aktivno i izravno uključeni u procjenu Transakcije,  \r\nb) priznati Povjerljive podatke kao vlasništvo druge ugovorne strane, \r\nc) koristiti Povjerljive podatke isključivo u svrhu procjene Transakcije te prema odredbama ovog Ugovora,  \r\nd) Povjerljive podatke ne kopirati (mehanički ili elektronski) ili na neki drugi način umnažati ili stavljati u pisani oblik, osim ukoliko ugovorna strana koja prima Povjerljive podatke ishodi suglasnost druge ugovorne strane ili ako je to potrebno za ostvarenje ovog Ugovora, \r\ne) na zahtjev druge ugovorne strane, u svako doba vratiti, uništiti,  odnosno trajno izbrisati sve informacije koje su u vezi ili proizlaze iz Povjerljivih podataka, kao i sve njihove kopije te pružiti potvrde o uništenju ili brisanju, ukoliko je to moguće.',
        value: '',
    }],
},
{
title: 'IZUZECI',
mandatory: true,
statements: [
    {
        type: 'text',
        required: false,
        mandatory: true,
        editable: true,
        content: 'Obveze ugovornih strana koje se odnose na povjerljivost i nekorištenje neće se primjenjivati, ili će se prestati primjenjivati, na bilo koje Povjerljive podatke ako ili kada takvi Povjerljivi podaci:\r\na) su bili izričito poznati drugoj ugovornoj strani prije primitka Povjerljivih podataka, i/ili \r\nb) u bili, ili postanu (ali ne zbog kršenja obveza ugovorne strane iz ovog Ugovora) poznati javnosti ili postanu dostupni javnosti u vrijeme njihovog priopćavanja drugoj ugovornoj strani, i/ili \r\nc) postanu poznati primatelju informacija iz izvora različitih od ugovorne strane pod okolnostima koje ne uključuju, prema najboljem saznanju ugovorne strane, kršenje bilo koje obveze povjerljivosti od strane bilo koje osobe prema drugoj ugovornoj strani ili zakonskih propisa kojima se regulira tržište kapitala u Republici Hrvatskoj i/ili EU, i/ili \r\nd) su neovisno sastavljeni ili prikupljeni od strane druge ugovorne strane, i ne temelje se na, niti koriste Povjerljive podatke ili bilo koji njihov dio. \r\nNeće se smatrati povredom obveza povjerljivosti iz ovog Ugovora ako jedna od ugovornih strana otkrije Povjerljive podatke kada i u mjeri u kojoj je to otkrivanje obvezno na temelju zakona ili primjenjivih pravnih postupaka, pod uvjetom da u takvom slučaju ugovorna strana koja otkriva Povjerljive podatke, prije otkrivanja (i) bez odgađanja u pisanom obliku obavijesti drugu ugovornu stranu da je takvo otkrivanje obavezno ili može biti obavezno i (ii) u potpunosti surađuje s ugovornom stranom koja je otkrila Povjerljive podatke u zaštiti povjerljive ili vlasničke prirode Povjerljivih podataka. \r\nUgovorne strane, niti bilo koja od njihovih povezanih osoba neće kao rezultat sklapanja ovog Ugovora biti obvezni međusobno ili njihove povezane osobe, sklapati bilo kakve daljnje Ugovore bilo koje vrste.',
        value: '',
    }],
},  
{
title: 'AUTORSKA PRAVA, PARTNERSTVA',
mandatory: false,
statements: [
    {
        type: 'text',
        required: false,
        mandatory: true,
        editable: true,
        content: 'Ništa u ovom Ugovoru, uključujući bilo kakvo otkrivanje Povjerljivih podataka u skladu s ovim Ugovorom, ne može se tumačiti kao prijenos bilo kojeg prava intelektualnog vlasništva, uključujući patente, autorska prava, žigove, poslovne tajne, know-how ili drugih prava na Ugovornu stranu koja dobiva podatke niti će licencirati ili prenijeti bilo koje pravo, naslov ili korist iz Povjerljivih podataka na ugovornu stranu koja dobiva pristup Povjerljivim podacima, te su Povjerljivi podaci i nadalje vlasništvo Ugovorne strane koja je otkrila Povjerljive podatke.\r\nOvaj Ugovor se ne može tumačiti kao obveza sklapanja daljnjih ugovora te neće utvrditi niti podrazumijevati bilo kakav daljnji odnos između Ugovornih strana, odnosno stvaranje partnerstva, joint venture ili agencijskog odnosa.',
        value: '',
    }],
}, 
{
title: 'TRAJANJE OBVEZE POVJERLJIVOSTI',
mandatory: true,
statements: [
    {
        type: 'input',
        mandatory: true,
        editable: false,
        parts: [
            {type: 'text', content: '​Obveza čuvanja tajnosti prestaju protekom'},
            {type: 'input', value: '', required: true, },
            {type: 'text', content: 'od dana potpisivanja ovog Ugovora, uz iznimku onih Povjerljivih podataka koje se sukladno zakonskim propisima moraju trajno čuvati tajnima.'}],
    }],
},
{
title: 'PRIVREMENA MJERA',
mandatory: false,
statements: [
    {
        type: 'text',
        required: false,
        mandatory: true,
        editable: true,
        content: 'Bez prejudiciranja prava i pravnih lijekova koji su i inače na raspolaganju svakoj od ugovornih strana, pružatelj informacija ovlašten je ishoditi privremenu mjeru pred nadležnim sudovima bilo koje države, ako primatelj informacija  ili bilo koji od njenih zastupnika prekrši ili zaprijeti kršenjem bilo koje od odredbi ovog Ugovora.          ',
        value: '',
    }],
}, 
{
  title: 'NADLEŽNOST',
  mandatory: true,
  statements: [
      {
          type: 'input',
          mandatory: true,
          editable: false,
          parts: [
              {type: 'text', content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u', required: true,},
              { type: "input", value: "", help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true },
            ],
      }],
  value: '',
},

    {
        title: 'PRIMJENA UGOVORA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
                value: '',
            }],
    },
    {
      title: 'PRIMJERCI UGOVORA',
      mandatory: false,
      statements: [
          {
              type: 'text',
              required: false,
              mandatory: true,
              editable: true,
              content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
              value: '',
          }],
    },
    {
        mandatory: true,
        static: true,
        type: 2, // date and place
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              {
                type: "text",
                content: "U"
              },
              {
                type: "input",
                value: "",
                placeholder: "Upišite mjesto.",
                required: true,
              },
              {
                type: "text",
                content: ", dana"
              },
              {
                type: "date",
                value: new Date(),
                required: true
              },
              {
                type: "text",
                content: "godine."
              }
            ]
          },
        ]
      },
    {
        mandatory: true,
        static: true,
        type: 3,  // signatures
        statements: [],
    },
],
};




// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/202.1_ugovor_o_povjerljivosti2.ts